module.exports = __webpack_public_path__ + "img/main-moon.bfa193aa.png";